import { NavLink } from '@bcm-dev/bcms-vite';
import React from 'react';
import { SVGAsset } from 'res';
import './styles.css';

export default function TabsContainer(props) {
  const className = props.className ?? "";

  return(
    <div className={className + " tabs-container flex-container flex-horizontal align-center-container text-center bottom-border"}>
      {props.children}
    </div>
  );
}

export function TabItem(props) {
  const icon = props.icon !== undefined ? (<SVGAsset id={props.icon} className="set-width left-inline-icon" />) : (<></>)
  const text = props.text ?? "[Tab Text]";
  const className = props.className ?? "";
  const dataPoint = props.dataPoint ?{"data-point":props.dataPoint}:{};
  return(
    <NavLink className={className + " tab-item flex-width"} activeRoutes={props.activeRoute} activeClassName={ props.activeClass } to={props.route}>
      <div className="tab-item-content text-center">
        {icon}
        <span className="tab-text set-width" {...dataPoint}>{text}</span>
      </div>
    </NavLink>
  );
}